import React from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../Components/ScrollReveal/ScrollReveal";
import KineticText from "../Components/KineticText";

const Career = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-5 sm:w-[70%] mx-auto md:px-20 overflow-x-hidden">
      {/* Header Section */}
      <ScrollReveal className="text-center" direction="up">
        <KineticText as="p" splitBy="word" className="text-gray-600 text-lg mt-24 heading-font">
          Discover exciting opportunities and become part of our journey.
        </KineticText>
      </ScrollReveal>

      {/* Vacancy List */}
      <ScrollReveal className="mt-10" stagger={0.15}>
        <KineticText as="h2" splitBy="char" className="text-2xl font-semibold text-gray-800 mb-6 heading-font">
          Current Openings
        </KineticText>

        <div className="bg-white shadow-md rounded-lg p-6 hover:-translate-y-2 transition duration-300">
          {/* Job Card */}
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <h3 className="text-xl font-medium text-gray-800">
                Product Development Manager
              </h3>
              <p className="text-gray-600">
                Location: Biravo, Narayanganj, Dhaka. | Full-Time
              </p>
            </div>
            <Link
              to="/career/apply"
              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded transition"
            >
              Apply Now
            </Link>
          </div>
        </div>
      </ScrollReveal>
      <ScrollReveal className="mt-10">
        <div className="bg-white shadow-md rounded-lg p-6 hover:-translate-y-2 transition duration-300">
          {/* Job Card */}
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <h3 className="text-xl font-medium text-gray-800">
                Graphics Designer
              </h3>
              <p className="text-gray-600">
                Location: Biravo, Narayanganj, Dhaka. | Full-Time
              </p>
            </div>
            <a
              href="mailto:vacancy.nextcare@gmail.com?subject=Application%20for%20Graphics%20Designer"
              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded transition"
            >
              Apply Now
            </a>
          </div>
        </div>
      </ScrollReveal>
    </div>
  );
};

export default Career;
